import { Button } from "primereact/button";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { useContext, useEffect, useState } from "react";
import { InputTextarea } from "primereact/inputtextarea";
import AddTotalDiscountDialog from "../../../../../dialogs/AddTotalDiscountDialog";
import SalesNoteDialog from "../sales-dialogs/SalesNoteDialog";
import UiContext from "../../../../../store/ui-context";
import CustomerDiscountSelectorMain from "../../../../../features/selectors/customer-discount-selector/component/customer-discount-selector-main";

const InvoiceControlSection = (props) => {
  const {
    width,
    data,
    onChangeSalesDiscount,
    onVoidSales,
    loading,
    onChangeNote,
  } = props;

  const uiContext = useContext(UiContext);
  const [visibleTotalDiscountDialog, setVisibleTotalDiscountDialog] = useState(false);
  const [visibleCustomerDiscountDialog, setVisibleCustomerDiscountDialog] = useState(false);
  const [visibleNoteDialog, setVisibleNoteDialog] = useState(false);
  const [visibleVoidNoteDialog, setVisibleVoidNoteDialog] = useState(false);

  const handleClickDiscount = (salesItemId) => {
    if (data.customer_id) {
      setVisibleTotalDiscountDialog(true);
    } else {
      uiContext.showErrorMsg("Error", "Please select a customer first");
    }
  };

  const handleClickCustomerDiscount = (salesItemId) => {
    if (data.customer_id) {
      setVisibleCustomerDiscountDialog(true);
    } else {
      uiContext.showErrorMsg("Error", "Please select a customer first");
    }
  };

  const handleVoidSales = () => {
    if (data.customer_id) {
      confirmDialog({
        message: "Are you sure you want to void this sales?",
        header: "Confirmation",
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          setVisibleVoidNoteDialog(true);
          // onVoidSales();
        },
      });
    } else {
      uiContext.showErrorMsg("Error", "Please select a customer first");
    }
  };

  const handleClickChangeNote = () => {
    if (data.customer_id) {
      setVisibleNoteDialog(true);
    } else {
      uiContext.showErrorMsg("Error", "Please select a customer first");
    }
  };

  console.log("rendering InvoiceControlSection", data);

  return (
    <div className={`col-start-center ${width} gap-1`}>
      <AddTotalDiscountDialog
        visible={visibleTotalDiscountDialog}
        onHide={(e) => setVisibleTotalDiscountDialog(false)}
        onConfirm={(e, discount) => {
          if (discount && discount.length > 0) {
            onChangeSalesDiscount({ discount });
            setVisibleTotalDiscountDialog(false);
          }
        }}
      />
      <CustomerDiscountSelectorMain
        visible={visibleCustomerDiscountDialog}
        onHide={(e) => setVisibleCustomerDiscountDialog(false)}
        onConfirm={(e, discount) => {
          if (discount && discount.length > 0) {
            discount[0].discount_type = discount[0].type;
            discount[0].customer_discount_id = discount[0].id;
            onChangeSalesDiscount({ discount });
            setVisibleCustomerDiscountDialog(false);
          }
        }}
        additionalFilter={`customer_id:=:${data.customer_id}`}
      />

      <SalesNoteDialog
        visible={visibleNoteDialog}
        onHide={(e) => setVisibleNoteDialog(false)}
        data={data.notes}
        title={"Sales Note"}
        onConfirm={(note) => {
          onChangeNote({ note });
          setVisibleNoteDialog(false);
        }}
        loading={loading}
      />

      <SalesNoteDialog
        visible={visibleVoidNoteDialog}
        onHide={(e) => setVisibleVoidNoteDialog(false)}
        data={data.voided_reason ?? ""}
        title={"Void Reason"}
        onConfirm={(voidReason) => {
          if (voidReason && voidReason.length > 0) {
            onVoidSales(voidReason);
            setVisibleVoidNoteDialog(false);
          }
        }}
        loading={loading}
      />

      <ConfirmDialog
        pt={{
          acceptButton: { className: "p-button-danger" },
        }}
      />
      <div className={`row-center-center ${width} gap-1`}>
        <Button
          loading={loading}
          className="max-h-[2rem] bg-red-400 border-red-400"
          icon="pi pi-trash"
          label="Void"
          onClick={(e) => {
            e.preventDefault();
            handleVoidSales();
          }}
        />
        <Button
          loading={loading}
          className="max-h-[2rem]"
          icon="pi pi-tag"
          label="Disc"
          onClick={(e) => {
            e.preventDefault();
            handleClickDiscount();
          }}
        />
        <Button
          loading={loading}
          className="max-h-[2rem] bg-green-600 border-green-600"
          icon="pi pi-percentage"
          label="Disc"
          onClick={(e) => {
            e.preventDefault();
            handleClickCustomerDiscount();
          }}
        />
        <Button
          loading={loading}
          className="max-h-[2rem]"
          icon="pi pi-pencil"
          label="Note"
          onClick={(e) => {
            e.preventDefault();
            handleClickChangeNote();
          }}
        />
      </div>
    </div>
  );
};

export default InvoiceControlSection;
